import { useQContent } from '@exam-management/common/qcontent-provider';
import { Flex, ReadonlyField } from '@shared/components';

import { QuestionContentPreviewer, QuestionChoiceList } from '../../components';

export default function DetailView() {
  const { qContent } = useQContent();

  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
      <ReadonlyField
        content={
          <QuestionContentPreviewer content={qContent.details ?? ''} questionId={qContent.id} />
        }
      />
      <QuestionChoiceList
        choices={qContent.metadata.choices}
        value={qContent.correctAnswer?.value ?? ''}
        questionId={qContent.id}
      />
    </Flex>
  );
}
